// src/components/Seo.jsx
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SITE = 'https://nyx.baby';

function cleanPath(pathname) {
    if (!pathname) return '/';
    // normalize: no trailing slash (except root)
    return pathname !== '/' && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
}

export default function Seo({
                                title,
                                description,
                                image = `${SITE}/og-default.jpg`, // TODO: replace with your real image
                                type = 'website',
                                robots = 'index,follow',
                            }) {
    const { pathname } = useLocation();
    const canonical = `${SITE}${cleanPath(pathname) || '/'}`;

    return (
        <Helmet>
            {/* Basic */}
            {title && <title>{title}</title>}
            {description && <meta name="description" content={description} />}
            <link rel="canonical" href={canonical} />
            <meta name="robots" content={robots} />

            {/* Open Graph */}
            {title && <meta property="og:title" content={title} />}
            {description && <meta property="og:description" content={description} />}
            <meta property="og:url" content={canonical} />
            <meta property="og:type" content={type} />
            <meta property="og:image" content={image} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            {title && <meta name="twitter:title" content={title} />}
            {description && <meta name="twitter:description" content={description} />}
            <meta name="twitter:image" content={image} />
        </Helmet>
    );
}